import CreateValueModule from "@/redux/create-value-module";

import { $HeaderModuleName } from "./header.types";

const { constants: _constants, actions } = CreateValueModule(
    $HeaderModuleName,
    {
        flyoutActive: false,
        sidebarActive: false,
        mobile: false
    }
);

export const clear = actions.clear;
export const set = actions.set;
export const update = actions.update;

export const constants = _constants;
